// Dropdown actions menu for PEME status table rows
import React, { useState, useRef, useEffect } from 'react';
import { MoreHorizontal, Pencil } from 'lucide-react';

const ActionsMenu = ({ crew, isAdmin, onEdit, onViewProfile, onViewDocuments }) => {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  // Only attach click-outside listener when dropdown is open (avoids N listeners for N rows)
  useEffect(() => {
    if (!open) return;
    const handler = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, [open]);

  return (
    <div className="tw-flex tw-items-center tw-gap-2 tw-relative" ref={ref}>
      <button
        onClick={() => setOpen((v) => !v)}
        className="tw-p-1.5 tw-rounded-lg hover:tw-bg-slate-100 tw-border-0 tw-bg-transparent tw-cursor-pointer tw-text-gray-400 hover:tw-text-gray-600 tw-transition-colors"
        title="More options"
      >
        <MoreHorizontal className="tw-w-4 tw-h-4" />
      </button>

      {open && (
        <div className="tw-absolute tw-right-0 tw-top-8 tw-z-30 tw-bg-white tw-rounded-xl tw-shadow-lg tw-border tw-border-slate-100 tw-min-w-[168px] tw-py-1">
          <button
            onClick={() => { onViewProfile(crew); setOpen(false); }}
            className="tw-w-full tw-text-left tw-px-4 tw-py-2.5 tw-text-sm tw-text-gray-700 hover:tw-bg-slate-50 tw-bg-transparent tw-border-0 tw-cursor-pointer"
          >
            View Full Profile
          </button>
          <button
            onClick={() => { onViewDocuments(crew); setOpen(false); }}
            className="tw-w-full tw-text-left tw-px-4 tw-py-2.5 tw-text-sm tw-text-gray-700 hover:tw-bg-slate-50 tw-bg-transparent tw-border-0 tw-cursor-pointer"
          >
            View Documents
          </button>
        </div>
      )}
    </div>
  );
};

export default ActionsMenu;
